module.exports = __webpack_public_path__ + "img/mura.ef0943ff.png";